import React, { type MouseEvent } from 'react';
import { ShieldCheckIcon, ArrowRightIcon, LockIcon } from 'lucide-react';
import { OFFER_ID } from '../../utils/scrollToOffer';
import { CHECKOUT_URL, openCheckout } from '../../utils/checkout';
const included = ['Guía completa Curly Seducción', 'Test de porosidad y patrón', 'Bono 1 · Guía de ingredientes', 'Bono 2 · 12 recetas caseras', 'Bono 3 · Calendario de 30 días'];
export function OfferSection() {
  // Atajo: doble clic en cualquier punto del bloque de precio lleva al checkout.
  // El botón sigue siendo la vía principal y accesible.
  const handleCardDoubleClick = (event: MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement).closest('a')) return;
    openCheckout();
  };
  return <section id={OFFER_ID} className="scroll-mt-6 border-b border-white/5 bg-ink py-20" aria-labelledby="offer-title" data-id="element-80" data-mp="2r299yogh1bai">
      <div className="mx-auto w-full max-w-4xl px-6" data-id="element-81" data-mp="3jkwo1jx1vq23">
        <div onDoubleClick={handleCardDoubleClick} className="rounded-xl border border-gold/30 bg-cocoa p-8 sm:p-12" data-id="element-82" data-mp="3jlo940t0u5e4">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-83" data-mp="365557bcwoo4x">
            Oferta de lanzamiento
          </p>
          <h2 id="offer-title" className="mt-4 font-display text-3xl text-cream sm:text-4xl" data-id="element-84" data-mp="3kv41f8kwhphr">
            Todo el método, un solo pago
          </h2>

          <div className="mt-8 grid gap-10 sm:grid-cols-[1fr_auto] sm:items-start" data-id="element-85" data-mp="3ttxsykjdjpog">
            <ul className="space-y-2.5" data-id="element-86" data-mp="3tw24nonilsza">
              {included.map(item => <li key={item} className="flex items-start gap-3 text-sand" data-id="element-87" data-mp="3pup1xnfpy5wl">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 rounded-full bg-gold" data-id="element-88" data-mp="7mhgk6z0j7p5" />
                  <span data-id="element-89" data-mp="2ofynpdbpef9">{item}</span>
                </li>)}
            </ul>

            <div className="sm:text-right" data-id="element-90" data-mp="29f5o2siowhaq">
              <p className="text-sm text-sand/70" data-id="element-91" data-mp="24f9hqmmisds0">
                Precio normal <span className="line-through" data-id="element-92" data-mp="24gudugohg4rz">$27.00</span>
              </p>
              <p className="mt-1 font-display text-6xl leading-none text-gold-soft" data-id="element-93" data-mp="8d6emd5fsghn">$6.39</p>
              <p className="mt-2 text-sm text-sand" data-id="element-94" data-mp="dag4tv0ngw6j">Pago único · Descarga inmediata</p>
              <p className="mt-3 inline-flex items-center rounded-full border border-gold/40 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-95" data-mp="hcbd5jh009tt">
                76% de descuento hoy
              </p>
            </div>
          </div>

          <a href={CHECKOUT_URL} rel="noopener noreferrer" onClick={openCheckout} className="add-to-cart mt-10 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-96" data-mp="r8wjq98o1szr">
            Quiero mis rizos definidos
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="1f1d2km089p04" />
          </a>

          <p className="mt-4 flex items-center justify-center gap-2 text-xs text-sand/80" data-id="element-98" data-mp="1p5joxhtgegth">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-99" data-mp="1k55q8qdqsj84" />
            Pago seguro · Recibes el acceso en tu correo al instante
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start gap-4 border border-white/10 p-6 sm:flex-row sm:items-center" data-id="element-100" data-mp="1f85j0c55paff">
          <ShieldCheckIcon className="h-10 w-10 shrink-0 text-gold" aria-hidden="true" data-id="element-101" data-mp="27uqb5etghqk1" />
          <div data-id="element-102" data-mp="22vwujdivhjfn">
            <h3 className="font-display text-2xl text-cream" data-id="element-103" data-mp="22vet82hcsf0v">Garantía de 10 días</h3>
            <p className="mt-1 text-sand" data-id="element-104" data-mp="1y4yemf1sqncx">
              Prueba el método 10 días. Si tu rizo no cambia, escribes a soporte y te
              devolvemos el 100%. Sin preguntas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}